import { StaticBaseDao } from '@/dao';
import { EventImplementation, PostResponse } from '@/objects/generated';

export class EventImplementationDao extends StaticBaseDao {
    public static async SaveImplementations(EventID: number, baseObjects: EventImplementation[]): Promise<PostResponse | null> {
        return this.BaseFetch(
            PostResponse,
            `EventImplementation/SaveImplementations` + '?' + (EventID == undefined ? '' : `EventID=${EventID}`),
            'POST',
            baseObjects,
        );
    }
}
